export interface PhoneCountry {
  code: string;
  flag: string;
  name: string;
  dialCode: string;
  mask: string;
}

export const countries: PhoneCountry[] = [
  { code: 'gb', flag: '🇬🇧', name: 'United Kingdom', dialCode: '+44', mask: '+44 9999 999999' },
  { code: 'lv', flag: '🇱🇻', name: 'Latvia', dialCode: '+371', mask: '+371 99 999 999' },
  { code: 'pl', flag: '🇵🇱', name: 'Poland', dialCode: '+48', mask: '+48 999 999 999' },
  { code: 'lt', flag: '🇱🇹', name: 'Lithuania', dialCode: '+370', mask: '+370 999 99 999' },
  { code: 'ro', flag: '🇷🇴', name: 'Romania', dialCode: '+40', mask: '+40 999 999 9999' },
  { code: 'rs', flag: '🇷🇸', name: 'Serbia', dialCode: '+381', mask: '+381 99 9999999' },
  { code: 'sk', flag: '🇸🇰', name: 'Slovakia', dialCode: '+421', mask: '+421 999 999999' },
  { code: 'si', flag: '🇸🇮', name: 'Slovenia', dialCode: '+386', mask: '+386 99 999999' },
  { code: 'hr', flag: '🇭🇷', name: 'Croatia', dialCode: '+385', mask: '+385 99 999 9999' },
  { code: 'de', flag: '🇩🇪', name: 'Germany', dialCode: '+49', mask: '+49 9999 9999999' },
  { code: 'al', flag: '🇦🇱', name: 'Albania', dialCode: '+355', mask: '+355 99 999 9999' },
  { code: 'ad', flag: '🇦🇩', name: 'Andorra', dialCode: '+376', mask: '+376 999 999' },
  { code: 'at', flag: '🇦🇹', name: 'Austria', dialCode: '+43', mask: '+43 999 9999999' },
  { code: 'by', flag: '🇧🇾', name: 'Belarus', dialCode: '+375', mask: '+375 99 999 99 99' },
  { code: 'be', flag: '🇧🇪', name: 'Belgium', dialCode: '+32', mask: '+32 999 99 99 99' },
  { code: 'ba', flag: '🇧🇦', name: 'Bosnia and Herzegovina', dialCode: '+387', mask: '+387 99 999999' },
  { code: 'bg', flag: '🇧🇬', name: 'Bulgaria', dialCode: '+359', mask: '+359 999 999999' },
  { code: 'cy', flag: '🇨🇾', name: 'Cyprus', dialCode: '+357', mask: '+357 99 999999' },
  { code: 'cz', flag: '🇨🇿', name: 'Czech Republic', dialCode: '+420', mask: '+420 999 999 999' },
  { code: 'dk', flag: '🇩🇰', name: 'Denmark', dialCode: '+45', mask: '+45 99 99 99 99' },
  { code: 'ee', flag: '🇪🇪', name: 'Estonia', dialCode: '+372', mask: '+372 9999 9999' },
  { code: 'fo', flag: '🇫🇴', name: 'Faroe Islands', dialCode: '+298', mask: '+298 999999' },
  { code: 'fi', flag: '🇫🇮', name: 'Finland', dialCode: '+358', mask: '+358 999 9999999' },
  { code: 'fr', flag: '🇫🇷', name: 'France', dialCode: '+33', mask: '+33 9 99 99 99 99' },
  { code: 'gi', flag: '🇬🇮', name: 'Gibraltar', dialCode: '+350', mask: '+350 99999999' },
  { code: 'gr', flag: '🇬🇷', name: 'Greece', dialCode: '+30', mask: '+30 999 999 9999' },
  { code: 'hu', flag: '🇭🇺', name: 'Hungary', dialCode: '+36', mask: '+36 99 999 9999' },
  { code: 'is', flag: '🇮🇸', name: 'Iceland', dialCode: '+354', mask: '+354 999 9999' },
  { code: 'ie', flag: '🇮🇪', name: 'Ireland', dialCode: '+353', mask: '+353 99 999 9999' },
  { code: 'it', flag: '🇮🇹', name: 'Italy', dialCode: '+39', mask: '+39 999 999 9999' },
  { code: 'li', flag: '🇱🇮', name: 'Liechtenstein', dialCode: '+423', mask: '+423 999 9999' },
  { code: 'lu', flag: '🇱🇺', name: 'Luxembourg', dialCode: '+352', mask: '+352 999 999 999' },
  { code: 'mk', flag: '🇲🇰', name: 'North Macedonia', dialCode: '+389', mask: '+389 99 999 999' },
  { code: 'mt', flag: '🇲🇹', name: 'Malta', dialCode: '+356', mask: '+356 9999 9999' },
  { code: 'md', flag: '🇲🇩', name: 'Moldova', dialCode: '+373', mask: '+373 9999 9999' },
  { code: 'mc', flag: '🇲🇨', name: 'Monaco', dialCode: '+377', mask: '+377 99 999 999' },
  { code: 'me', flag: '🇲🇪', name: 'Montenegro', dialCode: '+382', mask: '+382 99 999999' },
  { code: 'nl', flag: '🇳🇱', name: 'Netherlands', dialCode: '+31', mask: '+31 99 999 9999' },
  { code: 'no', flag: '🇳🇴', name: 'Norway', dialCode: '+47', mask: '+47 999 99 999' },
  { code: 'pt', flag: '🇵🇹', name: 'Portugal', dialCode: '+351', mask: '+351 999 999 999' },
  { code: 'ru', flag: '🇷🇺', name: 'Russia', dialCode: '+7', mask: '+7 999 999 99 99' },
  { code: 'sm', flag: '🇸🇲', name: 'San Marino', dialCode: '+378', mask: '+378 999999999' },
  { code: 'es', flag: '🇪🇸', name: 'Spain', dialCode: '+34', mask: '+34 999 999 999' },
  { code: 'se', flag: '🇸🇪', name: 'Sweden', dialCode: '+46', mask: '+46 999 999 9999' },
  { code: 'ch', flag: '🇨🇭', name: 'Switzerland', dialCode: '+41', mask: '+41 99 999 99 99' },
  { code: 'tr', flag: '🇹🇷', name: 'Turkey', dialCode: '+90', mask: '+90 999 999 99 99' },
  { code: 'ua', flag: '🇺🇦', name: 'Ukraine', dialCode: '+380', mask: '+380 99 999 9999' },
  { code: 'va', flag: '🇻🇦', name: 'Vatican City', dialCode: '+379', mask: '+379 999999999' },
  { code: 'us', flag: '🇺🇸', name: 'United States', dialCode: '+1', mask: '+1 (999) 999-9999' },
  { code: 'am', flag: '🇦🇲', name: 'Armenia', dialCode: '+374', mask: '+374 99 999999' },
];

export const DEFAULT_COUNTRY_CODE = 'gb';

export const countryByCode = (code?: string): PhoneCountry =>
  countries.find(c => c.code === code) || countries[0];

export const stripNonDigits = (s: string) => s.replace(/\D/g, '');
export const dialCodeDigits = (c: PhoneCountry) => c.dialCode.replace(/\D/g, '');

interface MaskParts {
  prefix: string;
  pattern: string;
  slots: number;
}

// Keyed on PhoneCountry object identity — safe only because `countries` is a single
// module-level array. Don't turn it into a factory or spread it.
const maskCache = new WeakMap<PhoneCountry, MaskParts>();
export const splitMask = (country: PhoneCountry): MaskParts => {
  const cached = maskCache.get(country);
  if (cached) return cached;
  // Start looking past the dial code — otherwise a dial code that contains a 9 (+49, +39,
  // +90, +359, +389, +379, +298) is read as the first mask slot, which both over-counts the
  // expected digits and shifts the formatted display.
  const firstSlot = country.mask.indexOf('9', country.dialCode.length);
  const prefix = country.mask.slice(0, firstSlot);
  const pattern = country.mask.slice(firstSlot);
  const slots = (pattern.match(/9/g) || []).length;
  const parts: MaskParts = { prefix, pattern, slots };
  maskCache.set(country, parts);
  return parts;
};

export const formatLocal = (pattern: string, digits: string): string => {
  if (!digits) return '';
  let out = '';
  let d = 0;
  for (let i = 0; i < pattern.length; i++) {
    if (d >= digits.length) break;
    const ch = pattern[i];
    if (ch === '9') {
      out += digits[d++];
    } else {
      out += ch;
    }
  }
  return out;
};

export const formatDisplay = (country: PhoneCountry, localDigits: string): string => {
  if (!localDigits) return '';
  const { prefix, pattern } = splitMask(country);
  return prefix + formatLocal(pattern, localDigits);
};

const sortedByDialDesc = [...countries].sort(
  (a, b) => dialCodeDigits(b).length - dialCodeDigits(a).length
);

export const detectCountryByDigits = (allDigits: string): PhoneCountry | null => {
  if (!allDigits) return null;
  return sortedByDialDesc.find(c => allDigits.startsWith(dialCodeDigits(c))) || null;
};

export const extractLocalDigits = (allDigits: string, country: PhoneCountry): string => {
  const dial = dialCodeDigits(country);
  if (allDigits.startsWith(dial)) {
    return allDigits.slice(dial.length);
  }
  return allDigits;
};

export const applyCountryRules = (country: PhoneCountry, localDigits: string): string => {
  // UK numbers should not include trunk prefix zero after +44.
  if (country.code === 'gb' && localDigits.startsWith('0')) {
    return localDigits.slice(1);
  }
  return localDigits;
};

export const validatePhoneByCountry = (value: string = '', country: PhoneCountry = countries[0]) => {
  if (!value) return true;
  const allDigits = stripNonDigits(value);
  const localDigits = extractLocalDigits(allDigits, country);
  if (!localDigits) return true;
  if (country.code === 'gb' && localDigits.startsWith('0')) {
    return 'Please remove the first 0';
  }
  return localDigits.length === splitMask(country).slots || 'Invalid Mobile Number';
};

export const mobileNumberRules = {
  required: 'Phone Number is required',
};

/**
 * Masked version of a stored E.164 number, for display only — `+447911123456` reads as
 * `+44 7911 123456`. Returns the value untouched when the country can't be worked out.
 */
export const formatPhoneNumber = (value: string): string => {
  const digits = stripNonDigits(value);
  const country = detectCountryByDigits(digits);
  if (!country) {
    return value;
  }
  return formatDisplay(country, extractLocalDigits(digits, country)) || value;
};

/* ------------------------------------------------------------------ *
 * Parsing a pasted list of numbers
 * ------------------------------------------------------------------ */

export interface InvalidPhone {
  /** The token exactly as the user pasted it — they have to recognise it in the error list */
  raw: string;
  reason: string;
}

export interface ParsedPhoneList {
  /** E.164, deduped within the batch, input order preserved */
  valid: string[];
  /** Had digits but failed validation */
  invalid: InvalidPhone[];
  duplicatesInBatch: number;
  /** Tokens with no digits at all — names, column headers */
  ignored: number;
  /** At least one bare token was resolved against the default country */
  usedDefaultCountry: boolean;
}

// Newline, comma, semicolon, tab and pipe — plus whitespace right before a `+`.
// Never plain spaces on their own: `+44 7911 123456` is one number, not three.
const TOKEN_SEPARATORS = /[\n\r,;\t|]+|\s+(?=\+)/;

/** Tokens a pasted blob holds. Exported so the field can decide whether to intercept a paste. */
export const splitPhoneTokens = (text: string): string[] =>
  text
    .split(TOKEN_SEPARATORS)
    .map(token => token.trim())
    .filter(Boolean);

// Non-breaking/thin spaces and the unicode dashes spreadsheets like to insert
const INVISIBLE_OR_DASH = /[  -​‐-―−]/g;

/**
 * Turn pasted text into invite-ready numbers. Bare tokens (no `+`) are resolved against
 * `defaultCountryCode` — the country picked in the field — which is what makes a pasted
 * column of UK `07…` numbers work. A `+` prefix that matches no known dial code is
 * rejected rather than guessed at.
 */
export const parsePhoneList = (text: string, defaultCountryCode?: string): ParsedPhoneList => {
  const result: ParsedPhoneList = {
    valid: [],
    invalid: [],
    duplicatesInBatch: 0,
    ignored: 0,
    usedDefaultCountry: false,
  };
  if (!text) {
    return result;
  }

  const defaultCountry = countryByCode(defaultCountryCode);
  const seen = new Set<string>();

  splitPhoneTokens(text).forEach(token => {
    const cleaned = token.replace(INVISIBLE_OR_DASH, ' ').trim();
    const digits = stripNonDigits(cleaned);

    if (!digits) {
      result.ignored++;
      return;
    }

    const isInternational = cleaned.startsWith('+') || /^00\d/.test(cleaned);
    // `00` is the same intent as `+`, so drop it before detecting the dial code
    const dialDigits = isInternational && !cleaned.startsWith('+') ? digits.slice(2) : digits;

    let country: PhoneCountry;
    if (isInternational) {
      const detected = detectCountryByDigits(dialDigits);
      if (!detected) {
        // Dial codes are 1-3 digits, so an unknown one can't be sliced out of the digits
        // reliably — the row already shows the number, so the reason doesn't repeat it.
        result.invalid.push({ raw: token, reason: "Country code isn't supported" });
        return;
      }
      country = detected;
    } else {
      country = defaultCountry;
    }

    const local = applyCountryRules(country, extractLocalDigits(dialDigits, country));
    const { slots } = splitMask(country);

    if (local.length !== slots) {
      result.invalid.push({
        raw: token,
        reason: `${local.length < slots ? 'Too short' : 'Too long'} — ${local.length} digits, expected ${slots}`,
      });
      return;
    }

    const phone = country.dialCode + local;
    if (seen.has(phone)) {
      result.duplicatesInBatch++;
      return;
    }
    seen.add(phone);
    result.valid.push(phone);
    if (!isInternational) {
      // Only flag it once something was actually added this way — the summary copy
      // tells the user which country bare numbers landed in
      result.usedDefaultCountry = true;
    }
  });

  return result;
};
